import store from "../store";

export const getClientSituation = () => {
  const your_situation = store.getters.calc.your_situationsVal;

  if (!your_situation) return "-";
  if (!your_situation.length) return "-";
  if(your_situation.length === 1 && your_situation[0]=='') return "-"
  var situationsStr = [];
  var currentEl;

  for (var i = 0; i < your_situation.length; i++) {
    currentEl = store.getters.getYour_situations.filter(
      item => item.id === your_situation[i]
    );

    situationsStr.push(currentEl && currentEl[0] && currentEl[0].name ? currentEl[0].name : '')
  }

  return situationsStr.join(', ');
};
